import { LitElement, css, html } from "lit"
import { unsafeHTML } from "lit/directives/unsafe-html.js"
const { apiFetch } = window.wp
import { addQueryArgs } from "@wordpress/url"

const LOADING_SVG = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_OSmW{transform-origin:center;animation:spinner_T6mA .75s step-end infinite}@keyframes spinner_T6mA{8.3%{transform:rotate(30deg)}16.6%{transform:rotate(60deg)}25%{transform:rotate(90deg)}33.3%{transform:rotate(120deg)}41.6%{transform:rotate(150deg)}50%{transform:rotate(180deg)}58.3%{transform:rotate(210deg)}66.6%{transform:rotate(240deg)}75%{transform:rotate(270deg)}83.3%{transform:rotate(300deg)}91.6%{transform:rotate(330deg)}100%{transform:rotate(360deg)}}</style><g class="spinner_OSmW"><rect x="11" y="1" width="2" height="5" opacity=".14"/><rect x="11" y="1" width="2" height="5" transform="rotate(30 12 12)" opacity=".29"/><rect x="11" y="1" width="2" height="5" transform="rotate(60 12 12)" opacity=".43"/><rect x="11" y="1" width="2" height="5" transform="rotate(90 12 12)" opacity=".57"/><rect x="11" y="1" width="2" height="5" transform="rotate(120 12 12)" opacity=".71"/><rect x="11" y="1" width="2" height="5" transform="rotate(150 12 12)" opacity=".86"/><rect x="11" y="1" width="2" height="5" transform="rotate(180 12 12)"/></g></svg>`

export class LatestProducts extends LitElement {
	static properties = {
		products: { type: Array },
		loading: { type: Boolean },
		message: { type: String },
		nonce: { type: String },
		page: { type: Number },
		total_pages: { type: Number },
	}

	constructor() {
		super()
		this.products = []
		this.loading = false
		this.message = ""
		this.nonce = ""
		this.page = 1
		this.total_pages = 1
		this._swiperInitialized = false
	}

	connectedCallback() {
		super.connectedCallback()
		this.getLatestProducts()

		this.addEventListener("page-changed", async e => {
			if (e.detail && e.detail.page && e.detail.page !== this.page) {
				this.page = e.detail.page
				this.products = await this.getLatestProducts()
			}
		})
	}

	createRenderRoot() {
		return this
	}

	updated(changedProps) {
		if ( !this._swiperInitialized) {
			this.updateComplete.then(() => {
				const swiperEl = this.querySelector(".products-swiper")
				if (!swiperEl) return
				const params = {
					slidesOffsetAfter: 30,
					breakpoints: {
						320: {
							slidesPerView: 1.2,
							spaceBetween: 10,
						},
						480: {
							slidesPerView: 3.2,
							spaceBetween: 15,
						},
						768: {
							slidesPerView: 3.2,
							spaceBetween: 20,
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 20,
              allowSlideNext: false,
              allowSlidePrev: false,
						},
					},

					injectStyles: [
						`
          :host{
             width: 100%;
          }

          .swiper-button-next, .swiper-button-prev{
            background-color: #4B883C;
            border-radius: 50%;
            width: 38px;
            height: 38px;
          }
          .swiper-button-next svg, .swiper-button-prev svg{
            width: 8.42px;
            height: 14.576px;
          }
        `,
					],
				}

				Object.assign(swiperEl, params)
        

				swiperEl.initialize()

				this._swiperInitialized = true
			})
		}
	}

	async getLatestProducts() {
		this.loading = true
		this.message = ""

		let q = {
			page: this.page,
			per_page: 6,
			orderby: "date",
			order: "desc",
      price_min: 1,
			
		}

		const url = addQueryArgs(`/cf/latest`, q)
		console.log(url)

		try {
			const products = await apiFetch({
				path: url,
				method: "GET",
				headers: {
					"X-WP-Nonce": this.nonce,
				},
			})

			if (Array.isArray(products)) {
				this.products = products
			} else {
				this.message = "No products found."
			}
		} catch (error) {
			console.error("Error fetching products:", error)
			this.message = "Error fetching products."
		} finally {
			this.loading = false
		}
		return this.products
	}

	render() {
		return html`
			<div class="products-container">
				<swiper-container
					equal-height
					init="false"
					space-between="20"
					class="products-swiper">
					${this.loading
						? html`<div class="loading">${unsafeHTML(LOADING_SVG)}</div>`
						: ""}
					${this.message
						? html`<div class="message">${this.message}</div>`
						: ""}
					${this.products.map(
						product => html`
							<swiper-slide>
								<product-listing .product="${product}"></product-listing>
							</swiper-slide>
						`
					)}
				</swiper-container>
			</div>
		`
	}
}
